<div [formGroup]="form" class="composition-control">
  <div class="composition-row">
    <label class="composition-label">Wertetyp</label>
    <nb-select fullWidth formControlName="valueType" placeholder="Wertetyp wählen">
      @for (v of valueTypes; track v) {
        <nb-option [value]="v">{{ v | valueTypeTranslation }}</nb-option>
      }
    </nb-select>
  </div>

  <div class="composition-row">
    <label class="composition-label">Elementtyp</label>
    <nb-select fullWidth formControlName="cardinalityType" placeholder="Elementtyp wählen">
      @for (v of cardinalityTypes; track v) {
        <nb-option [value]="v">{{ v | elementTypeTranslation }}</nb-option>
      }
    </nb-select>
  </div>

  @if (hasUnit) {
    <div class="composition-row">
      <label class="composition-label">Einheit</label>
      <nb-select fullWidth formControlName="unit" placeholder="Einheit wählen (optional)">
        <nb-option [value]="null">Keine</nb-option>
        @for (u of units; track u) {
          <nb-option [value]="u">{{ u }}</nb-option>
        }
      </nb-select>
    </div>
  }

  @if (isMultipleChoice) {
    <div class="composition-row">
      <label class="composition-label">Auswahloptionen</label>
      <div class="options-container">
        @if (multipleChoiceOptions.length > 0) {
          <div class="options-list">
            @for (opt of multipleChoiceOptions; track $index) {
              <div class="option-row">
                <nb-icon icon="radio-button-on-outline" pack="eva" class="option-icon"></nb-icon>
                <span class="option-text">{{ opt }}</span>
                @if (!form.disabled) {
                  <button type="button" class="remove-btn"
                          (click)="removeOption($index)" [attr.aria-label]="'Option ' + opt + ' entfernen'">
                    <nb-icon icon="close-outline" pack="eva"></nb-icon>
                  </button>
                }
              </div>
            }
          </div>
        }
        @if (!form.disabled) {
          <div class="add-option">
            <input nbInput fullWidth [(ngModel)]="newOption" [ngModelOptions]="{standalone: true}"
                   placeholder="Neue Option hinzufügen..." (keyup.enter)="addOption()">
            <button nbButton status="primary" size="small" type="button" (click)="addOption()">
              <nb-icon icon="plus-outline" pack="eva"></nb-icon>
              Hinzufügen
            </button>
          </div>
        }
      </div>
    </div>
  }

  @if (isTable) {
    <!-- Columns -->
    <div class="composition-row">
      <label class="composition-label">Spalten</label>
      @if (tableColumns.length > 0) {
        <div class="table-config-list">
          @for (col of tableColumns; track $index; let ci = $index) {
            <div class="table-config-item">
              <input nbInput fullWidth class="table-name-input" placeholder="Spaltenname"
                     [value]="col.name"
                     [disabled]="form.disabled"
                     (input)="updateTableColumn(ci, 'name', $any($event.target).value)" />
              <nb-select [selected]="col.type"
                         [disabled]="form.disabled"
                         (selectedChange)="updateTableColumn(ci, 'type', $event)"
                         class="table-type-select">
                @for (t of tableColumnTypes; track t) {
                  <nb-option [value]="t">{{ t }}</nb-option>
                }
              </nb-select>
              @if (!form.disabled) {
                <button nbButton ghost status="danger" size="tiny" type="button"
                        (click)="removeTableColumn(ci)">
                  <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
                </button>
              }
              <!-- Dropdown options -->
              @if (col.type === 'Dropdown') {
                <div class="dropdown-options">
                  @for (opt of col.options ?? []; track $index; let oi = $index) {
                    <div class="option-row">
                      <nb-icon icon="radio-button-on-outline" pack="eva" class="option-icon"></nb-icon>
                      <span class="option-text">{{ opt }}</span>
                      @if (!form.disabled) {
                        <button type="button" class="remove-btn" (click)="removeDropdownOption(ci, oi)">
                          <nb-icon icon="close-outline" pack="eva"></nb-icon>
                        </button>
                      }
                    </div>
                  }
                  @if (!form.disabled) {
                    <div class="add-option">
                      <input nbInput [(ngModel)]="col._newDropdownOption" [ngModelOptions]="{standalone: true}"
                             placeholder="Option hinzufügen..." (keyup.enter)="addDropdownOption(ci)" />
                      <button nbButton status="primary" size="tiny" type="button" (click)="addDropdownOption(ci)">
                        <nb-icon icon="plus-outline" pack="eva"></nb-icon>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      @if (!form.disabled) {
        <button nbButton ghost status="primary" size="small" type="button" (click)="addTableColumn()">
          <nb-icon icon="plus-outline" pack="eva"></nb-icon>
          Spalte hinzufügen
        </button>
      }
    </div>

    <!-- Rows -->
    <div class="composition-row">
      <label class="composition-label">Zeilen (fest)</label>
      @if (tableRows.length > 0) {
        <div class="table-config-list">
          @for (row of tableRows; track $index) {
            <div class="table-config-item">
              <input nbInput fullWidth class="table-name-input" placeholder="Zeilenname"
                     [value]="row.name"
                     [disabled]="form.disabled"
                     (input)="updateTableRow($index, $any($event.target).value)" />
              @if (!form.disabled) {
                <button nbButton ghost status="danger" size="tiny" type="button"
                        (click)="removeTableRow($index)">
                  <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
                </button>
              }
            </div>
          }
        </div>
      }
      @if (!form.disabled) {
        <button nbButton ghost status="primary" size="small" type="button" (click)="addTableRow()">
          <nb-icon icon="plus-outline" pack="eva"></nb-icon>
          Zeile hinzufügen
        </button>
      }
    </div>

    <!-- Allow add rows toggle -->
    <div class="composition-row">
      <label class="composition-label">Dynamische Zeilen erlauben</label>
      <nb-toggle [checked]="allowAddRows"
                 [disabled]="form.disabled"
                 (checkedChange)="allowAddRows = $event; emitValue()">
        Benutzer können Zeilen hinzufügen
      </nb-toggle>
    </div>
  }

</div>
